// organize-imports-ignore
import './index.shared';

import { setupAnalytics } from './src/functions/analytics';
import { setupCrashTracking } from './src/functions/debugging/crashTracking';
import { enableScreens } from 'react-native-screens';
import { registerRootComponent } from 'expo';
import { activateKeepAwake } from 'expo-keep-awake';
import { stopReportingRuntimeErrors } from 'react-error-overlay';
import App from './src/App';
import { Platform } from 'react-native';
import { safeMarkDevFlag } from './src/utils/safeMarkDevFlag';

if (__DEV__) {
  activateKeepAwake('dev-mode');

  // We're currently having a couple of annoying errors prompted
  // from time to time, thus we simply disable it in dev mode.
  const kDisableReactRefreshOverlay = safeMarkDevFlag(true);
  if (kDisableReactRefreshOverlay && Platform.OS === 'web') {
    stopReportingRuntimeErrors();
    document.body.classList.add('react-refresh-overlay-disabled');
  }
}

enableScreens();
// enableFreeze(true);

setupAnalytics();
setupCrashTracking();

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in the Expo client or in a native build,
// the environment is set up appropriately
registerRootComponent(App);

// navigator.userActivation polyfill on web, which is used to detect
// if the user has interacted with the browser so that we can enable audio
// when playing shows.
if (Platform.OS === 'web' && !('userActivation' in navigator)) {
  navigator.userActivation = { hasBeenActive: false };
  const userActivationClickHandler = e => {
    if (e.isTrusted) {
      navigator.userActivation.hasBeenActive = true;
      window.removeEventListener('click', userActivationClickHandler);
    }
  };
  window.addEventListener('click', userActivationClickHandler);
}

if (Platform.OS === 'web' && navigator.userAgent.indexOf('Windows') != -1) {
  if (document.documentElement.classList != null) {
    document.documentElement.classList.add('windows');
  }
}
